$(document).on("submit", ".product-card-form", function (e) {
  e.preventDefault();

  var form = $(this);
  var productId = form.find(".add-to-cart-button").data("product-id");

  console.log(productId);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      quantity: 1,
      id: productId,
    },
    success: function () {
      
      // Afficher la notification de succès
      alert("Produit ajouté au panier avec succès !");

      // Mettre à jour l'icône du panier dans la barre de navigation
      $.get("/cart.js", function (cart) {
        var cart1 = JSON.parse(cart);
        var itemCount = cart1.item_count || 0;
        var $cartCount = $(".cart-count");
        if ($cartCount.length) {
          $cartCount.removeClass("tw-hidden");
          $cartCount.text(itemCount);
        } else {
          var $cartIcon = $("a[data-slider-cart-open]");
          $cartIcon.append(
            '<span class="cart-count badge badge-primary position-absolute px-0 rounded-circle">' +
              itemCount +
              "</span>"
          );
        }
      });
    },
    error: function () {
      alert("Quantité insuffisante");
    },
  });
});
